import { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import AttachmentIcon from '@mui/icons-material/Attachment'
import api from 'services/api'
import Loader from 'components/core/Loader'
import Message from './Message'

const WelcomeMessages = () => {
  const [messageSets, setMessageSets] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    api.chat
      .getWelcomeMessages()
      .then(setMessageSets)
      .catch((e) => setError(e.message))
  }, [])

  if (!messageSets) return <Loader text="Loading messages" error={error} />

  return (
    <Box sx={{ p: 6, pt: 10, textAlign: 'center' }}>
      <Box sx={{ width: 800, maxWidth: '100%', margin: '0 auto' }}>
        {messageSets.length === 0 && (
          <Box sx={{ color: 'text.secondary' }}>
            No welcome message sets. New users aren't sent welcome messages.
          </Box>
        )}
        {messageSets.map((messageSet) => (
          <Box key={messageSet.id} sx={{ mb: 6 }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                fontWeight: 700,
                borderBottomWidth: 1,
                borderBottomColor: 'divider',
                borderBottomStyle: 'solid',
                pb: 1,
              }}
            >
              <Box>Message Set {messageSet.set_number}</Box>
              <Box>
                Schedule: {+parseFloat(messageSet.schedule_hours).toFixed(4)}{' '}
                hours
              </Box>
            </Box>
            {messageSet.messages.map((message, index) => (
              <Box key={index.toString()} sx={{ mt: 3 }}>
                <Box
                  sx={{
                    whiteSpace: 'pre-line',
                    backgroundColor: 'background.paper',
                    p: 1.5,
                    borderRadius: '1em',
                    textAlign: 'left',
                  }}
                >
                  <Message
                    text={message.text}
                    buttons={message.custom_data?.buttons}
                  />
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    mt: 0.5,
                  }}
                >
                  <Box>
                    {(message.attachments || []).map((attachment, index) => (
                      <AttachmentIcon
                        sx={{ cursor: 'pointer' }}
                        key={index.toString()}
                        onClick={() =>
                          window.open(attachment.asset_url, '_blank')
                        }
                      />
                    ))}
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default WelcomeMessages
